import { Component, Input } from '@angular/core';
import { UserKycApplicationDetailsDto } from '../../../../_core/_model/compliance';

@Component({
  selector: 'app-compliance-review-step',
  standalone: false,
  templateUrl: './compliance-review-step.html'
})
export class ComplianceReviewStep {
  @Input() application: UserKycApplicationDetailsDto | null = null;

  trackByField = (_: number, item: { fieldKey: string }) => item.fieldKey;
  trackByDoc = (_: number, item: { id: string }) => item.id;
}